import { Button, Divider, Modal } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import "./FormHelpInfoModal.scss";

type Props = {
  fields: Array<{ titleIntlKey: string; descriptionIntlKey: string }>;
  titleKey: string;
  descriptionKey?: string;
};

export const FormHelpInfoModal = ({ fields, titleKey, descriptionKey }: Props) => {
  const { formatMessage } = useIntl();
  const [isHelpSectionOpen, setIsHelpSectionOpen] = useState<boolean>(false);

  return (
    <>
      <Modal
        width={700}
        open={isHelpSectionOpen}
        onCancel={() => setIsHelpSectionOpen(false)}
        title={
          <div className="form-help-info-modal-title">
            <i className="fa-regular fa-circle-question" />
            {formatMessage({
              id: titleKey,
            })}
          </div>
        }
        footer={null}
      >
        {descriptionKey && (
          <span className="form-help-info-modal-description">{formatMessage({ id: descriptionKey })}</span>
        )}
        <div>{formatMessage({ id: "details" })}</div>
        <Divider className="form-help-info-modal-divider" />
        <div className="help-info-container">
          {fields.map((field) => (
            <div key={field.titleIntlKey}>
              <div className="help-label">{formatMessage({ id: `${field.titleIntlKey}` })}</div>
              <span className="help-description">{formatMessage({ id: `${field.descriptionIntlKey}` })}</span>
            </div>
          ))}
        </div>
      </Modal>
      <Button
        icon={<i className="fa-regular fa-circle-question" />}
        className="help-button"
        type="text"
        size="small"
        onClick={() => setIsHelpSectionOpen(true)}
      />
    </>
  );
};
